import { motion } from "framer-motion";
import { PRICING } from "@/lib/site";
import { Check, ArrowRight } from "lucide-react";

export default function Pricing() {
  return (
    <section id="precios" data-testid="pricing-section" className="relative py-20 md:py-28">
      <div className="max-w-[1160px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-14 items-end">
          <div className="col-span-12 md:col-span-8">
            <span className="chip mb-5">
              <span className="dot" /> Programa Distribución · Por invitación
            </span>
            <h2 className="font-display text-3xl md:text-5xl lg:text-[56px] font-bold text-[#0B0B14] tracking-tight leading-[1.05]">
              Tu tramo de precio queda <span className="text-[#5A48C9]">escriturado.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 text-[#3A3A48] leading-relaxed">
            Precios por unidad 1.0 mL, sin IVA. Solo se ofrece bajo compromiso de
            volumen mensual y evaluación previa. No es un e-commerce.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          {PRICING.map((p, i) => (
            <motion.div
              key={p.tier}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08 }}
              data-testid={`pricing-card-${p.tier.toLowerCase()}`}
              className={`relative p-7 md:p-8 flex flex-col rounded-[28px] ${
                p.highlight
                  ? "card-glass"
                  : "card-soft"
              }`}
            >
              {p.highlight && (
                <span className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-[#0B0B14] text-white text-[10px] font-bold uppercase tracking-widest">
                  Más elegido
                </span>
              )}

              <div className="flex items-center justify-between mb-8">
                <span className="text-[11px] font-semibold uppercase tracking-widest text-[#5A48C9]">
                  Tier {String(i + 1).padStart(2, "0")}
                </span>
              </div>

              <h3 className="font-display text-2xl font-bold text-[#0B0B14] tracking-tight">
                {p.tier}
              </h3>
              <p className="text-sm text-[#6B6B7D] mt-1">{p.units} unidades / mes</p>

              <div className="mt-8 mb-6">
                <div className="flex items-baseline gap-1">
                  <span className="font-display text-4xl sm:text-5xl xl:text-[42px] font-bold text-[#0B0B14] tracking-[-0.04em] leading-none">
                    ${p.price}
                  </span>
                </div>
                <p className="text-[11px] font-semibold uppercase tracking-widest text-[#6B6B7D] mt-2">
                  por unidad · sin IVA
                </p>
              </div>

              <ul className="space-y-2.5 mb-8 text-[14px] text-[#1E1E2C]">
                <li className="flex items-center gap-2">
                  <Check className="w-4 h-4 text-[#7C6AF5]" />
                  <span>Factura + Certificado ISP</span>
                </li>
                <li className="flex items-center gap-2">
                  <Check className="w-4 h-4 text-[#7C6AF5]" />
                  <span>Ejecutivo dedicado</span>
                </li>
              </ul>

              <p className="text-xs text-[#6B6B7D] leading-relaxed mb-6 mt-auto">
                {p.note}
              </p>

              <a
                data-testid={`pricing-cta-${p.tier.toLowerCase()}`}
                href="#contacto"
                className={`btn-pill ${p.highlight ? "btn-primary shine" : "btn-ghost"}`}
              >
                Cotizar este plan
                <ArrowRight className="w-4 h-4" />
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
